/* The Proper Set : moteur des dessins (03/10/2026).
   Chaque dessin anime porte data-a. Sans JS, ou en mouvement reduit, on voit le dessin FINI (rendu serveur).
   Avec JS : le dessin est arme (cache), puis joue une seule fois a son entree dans la vue.
   - .tr        : le trait se trace, sur sa longueur reelle a l'ecran (le trait constant ignore pathLength) ;
   - .fx-*      : mouvements CSS (ps-world.css), declenches par .is-on ;
   - fold       : la moitie du pliant tourne autour de sa charniere (matrice affine exacte) ;
   - clock      : la pendule decompte quelques secondes depuis l'heure affichee, une seule fois.
   Dates (data-ps-until / data-ps-after, epoch) : une page servie depuis le cache apres une date limite
   retire la date et montre le texte de remplacement. Tourne aussi en mouvement reduit. */
(() => {
  const now = Date.now() / 1000;
  document.querySelectorAll('[data-ps-until]').forEach(el => { if (+el.dataset.psUntil && now > +el.dataset.psUntil) el.hidden = true; });
  document.querySelectorAll('[data-ps-after]').forEach(el => { if (+el.dataset.psAfter && now > +el.dataset.psAfter) el.hidden = false; });
})();
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const arts = [...document.querySelectorAll('.ps-art[data-a]')];
  if (!arts.length) return;

  // longueur reelle a l'ecran d'un trait (le trait constant ignore pathLength) ; 0 si le trait n'est pas affiche
  const longueur = p => {
    if (!p.getTotalLength) return 0;
    const m = p.getScreenCTM(); if (!m) return 0;
    return Math.ceil(p.getTotalLength() * Math.max(Math.hypot(m.a, m.b), Math.hypot(m.c, m.d))) + 2;
  };
  // arme : le trait est cache des l'armement, sans quoi il s'affiche, s'efface puis se retrace
  const cacher = el => el.querySelectorAll('.tr').forEach(p => {
    const L = longueur(p); if (!L) return;
    p.style.strokeDasharray = L + ' ' + L; p.style.strokeDashoffset = L;
  });
  const tracer = (el, debut) => {
    el.querySelectorAll('.tr').forEach((p, i) => {
      const L = longueur(p); if (!L) { p.style.strokeDasharray = p.style.strokeDashoffset = ''; return; }
      p.style.strokeDasharray = L + ' ' + L; p.style.strokeDashoffset = '';
      p.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 1100, delay: debut + i * 45, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'backwards' })
        .onfinish = () => { p.style.strokeDasharray = ''; };
    });
  };

  // Pliant : t de 180 (ferme sur la moitie fixe) a 0 (a plat)
  const plier = (g, t) => {
    const n = s => g.dataset[s].split(',').map(Number);
    const O = n('o'), U = n('u'), V = n('v'), Z = n('z'), tau = +g.dataset.tau, l = +g.dataset.l, wl = +g.dataset.wl;
    const c = Math.cos(t), s = Math.sin(t);
    const w = [c * V[0] + s * Z[0], c * V[1] + s * Z[1]];
    const ep = [tau * (s * V[0] - c * Z[0]), tau * (s * V[1] - c * Z[1])];
    const mat = (a, b, o) => `matrix(${a[0]} ${a[1]} ${b[0]} ${b[1]} ${o[0]} ${o[1]})`;
    const dessus = U[0] * w[1] - U[1] * w[0] < 0;
    g.querySelector('.ps-fold__plane').setAttribute('transform', mat(U, w, O));
    g.querySelector('.ps-fold__top').style.display = dessus ? '' : 'none';
    g.querySelector('.ps-fold__back').style.display = dessus ? 'none' : '';
    g.querySelector('.ps-fold__side').setAttribute('transform', mat(w, ep, [O[0] + l * U[0], O[1] + l * U[1]]));
    const far = g.querySelector('.ps-fold__far');
    far.setAttribute('transform', mat(U, ep, [O[0] + wl * w[0], O[1] + wl * w[1]]));
    // une face dessinee sur (a, b) avec a x b = sa normale sortante est vue ssi det(a, b) < 0 (comme le dessus)
    far.style.display = U[0] * ep[1] - U[1] * ep[0] < 0 ? '' : 'none';
  };
  const deplier = el => {
    const g = el.querySelector('.fx-fold'); if (!g) return;
    const t0 = performance.now(), D = 1300;
    plier(g, Math.PI);
    const pas = now => {
      const k = Math.min(1, (now - t0 - 250) / D), e = k < 0 ? 0 : 1 - Math.pow(1 - k, 3);
      plier(g, Math.PI * (1 - e));
      if (k < 1) requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  };

  // Pendule : le cote leve decompte 6 secondes depuis l'heure affichee, puis s'arrete (joue une fois)
  const horloge = el => {
    const lab = el.querySelector('[data-l="l"]'); if (!lab) return;
    const m = /^(\d+):(\d\d)$/.exec(lab.textContent.trim()); if (!m) return;
    let t = +m[1] * 60 + +m[2], n = 0;
    const id = setInterval(() => {
      if (t > 0) t--; lab.textContent = Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0');
      if (++n >= 6 || !t) clearInterval(id);
    }, 1000);
  };

  const jouer = el => {
    el.classList.add('is-on');
    tracer(el, el.dataset.a === 'fig1' ? 0 : 100);
    if (el.dataset.a === 'fold') deplier(el);
    if (el.dataset.a === 'clock') horloge(el);
  };
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting && !e.target.classList.contains('is-on')) { jouer(e.target); io.unobserve(e.target); }
  }), { threshold: .3 });
  arts.forEach(el => { el.classList.add('is-armed'); cacher(el); io.observe(el); });

  // Un dessin ne reste pas arme si on l'a deja depasse (saut de defilement, ancre) : filet a 4 s
  setTimeout(() => arts.forEach(el => { if (!el.classList.contains('is-on') && el.getBoundingClientRect().bottom < 0) { el.classList.add('is-on'); el.querySelectorAll('.tr').forEach(p => { p.style.strokeDasharray = p.style.strokeDashoffset = ''; }); } }), 4000);
})();
/* Conquete 01/11/2026.
   - [data-ps-fit-add] : ajoute une variante au panier (racks qui vont, set + racks), puis rafraichit et ouvre le tiroir.
     data-ps-fit-add peut porter plusieurs ids separes par des virgules (le set prêt a jouer).
   - Les boutons express du tiroir sont reinitialises a chaque rafraichissement (le tiroir est remplace en AJAX). */
(() => {
  const ouvrir = () => { document.dispatchEvent(new CustomEvent('cart:refresh')); setTimeout(() => { const d = document.getElementById('cart-drawer'); if (d && d.show && !d.open) d.show(); }, 350); };
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-ps-fit-add]'); if (!b || b.disabled) return;
    e.preventDefault();
    const ids = b.dataset.psFitAdd.split(',').filter(Boolean);
    const old = b.textContent; b.disabled = true; b.textContent = 'Adding';
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(id => ({ id: +id, quantity: 1 })) }) });
      if (!r.ok) throw 0;
      b.textContent = 'Added'; ouvrir();
    } catch (err) { b.textContent = 'Not available'; }
    setTimeout(() => { if (b.isConnected) { b.disabled = false; b.textContent = old; } }, 2200);
  });
  document.addEventListener('cart-drawer:refreshed', () => { try { window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(); } catch (e) {} });
})();
